import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import {
  PATH_PARAMETERS_CERTIFICATES,
  PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE,
  PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE_ALIAS,
} from "./constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_CERTIFICATES,
    redirect: PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE,
  },
  {
    path: PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE,
    component: () => import("~/modules/certificate/views/CertificatesPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_CERTIFICATE),
      breadcrumb: BREADCRUMBS.TRUSTSTORE,
    },
  },
  {
    path: PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE_ALIAS,
    component: () => import("~/modules/certificate/views/CertificatesPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_CERTIFICATE),
      breadcrumb: BREADCRUMBS.TRUSTSTORE,
    },
  },
];

export default routes;
